import React from 'react';
import HeaderTeamLogo from '../components/HeaderTeamLogo';
import { useTeams } from '../hooks/team';

export default function HeaderTeamLogos() {
  const [teams, isLoading] = useTeams();

  if (!isLoading) {
    return <HeaderTeamLogo teams={teams} isLoading={isLoading} />;
  }
}
